exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-gradient-blue {\n  background: linear-gradient(90deg, #1C4C91 0%, #3A91F9 100%);\n}\n.bg-gradient-pink {\n  background: linear-gradient(90deg, #F98296 4.19%, #D8406C 100%);\n}", ""]);

// exports
